import { Bell, CalendarCheck, FileText, Search } from "lucide-react";
import Counter from "./Counter";

const APPOINTMENTS = [
  { time: "09:00", name: "Emma Wilson", tag: "Aligner check", tagColor: "bg-[#2563EB]/10 text-[#2563EB]" },
  { time: "09:30", name: "Liam Chen", tag: "New consult", tagColor: "bg-[#6366F1]/10 text-[#6366F1]" },
  { time: "10:15", name: "Sofia Reyes", tag: "Retainer fit", tagColor: "bg-emerald-500/10 text-emerald-600" },
];

const ACTIVITY = [
  { dot: "#2563EB", text: "AI drafted a clinical note for Emma W.", time: "2m ago" },
  { dot: "#6366F1", text: "Smile Coach update sent to Liam C.", time: "14m ago" },
  { dot: "#22C55E", text: "Appointment confirmed: Sofia R.", time: "32m ago" },
];

const STATS = [
  { label: "Today's Patients", value: 28, suffix: "", delta: "+6 vs avg", icon: CalendarCheck },
  { label: "AI Draft Notes", value: 14, suffix: "", delta: "Ready to approve", icon: FileText },
  { label: "Needing Review", value: 3, suffix: "", delta: "Priority flagged", icon: Bell },
  { label: "Time Saved Today", value: 58, suffix: " min", delta: "And counting", icon: Search },
];

export default function DashboardMockup() {
  return (
    <div
      data-testid="hero-dashboard-mockup"
      className="rounded-2xl border border-slate-200/80 bg-white shadow-[0_40px_90px_-20px_rgba(15,23,42,0.25)] overflow-hidden"
    >
      {/* Window chrome */}
      <div className="flex items-center gap-3 px-5 py-3 border-b border-slate-100 bg-slate-50/80">
        <div className="flex gap-1.5">
          <span className="w-2.5 h-2.5 rounded-full bg-[#FF5F57]" />
          <span className="w-2.5 h-2.5 rounded-full bg-[#FEBC2E]" />
          <span className="w-2.5 h-2.5 rounded-full bg-[#28C840]" />
        </div>
        <div className="flex-1 flex justify-center">
          <span className="text-[10px] font-medium text-slate-400 bg-white border border-slate-200 rounded-full px-4 py-1">
            app.alignexa.ai/dashboard
          </span>
        </div>
        <span className="w-8" />
      </div>

      <div className="p-5 sm:p-6">
        {/* Greeting */}
        <div className="flex items-center justify-between mb-5">
          <div>
            <p className="font-display font-medium text-lg text-[#0F172A] tracking-tight">
              Good morning, Dr. Sarah
            </p>
            <p className="text-xs text-slate-400 mt-0.5">Tuesday, Aug 3 · Your day at a glance</p>
          </div>
          <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#2563EB] to-[#6366F1] flex items-center justify-center text-white text-xs font-bold shadow-[0_6px_16px_rgba(37,99,235,0.35)]">
            S
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-5">
          {STATS.map((stat) => (
            <div
              key={stat.label}
              data-testid={`stat-${stat.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="rounded-xl border border-slate-100 bg-slate-50/60 p-3.5 transition-[box-shadow,transform] duration-300 hover:shadow-[0_10px_24px_rgba(15,23,42,0.08)] hover:-translate-y-0.5"
            >
              <p className="text-[10px] font-medium text-slate-400 leading-tight">{stat.label}</p>
              <p className="font-display font-semibold text-2xl text-[#0F172A] mt-1.5 tracking-tight">
                <Counter to={stat.value} suffix={stat.suffix} />
              </p>
              <p className="text-[10px] font-medium text-[#2563EB] mt-1">{stat.delta}</p>
            </div>
          ))}
        </div>

        <div className="grid sm:grid-cols-2 gap-3">
          {/* Upcoming appointments */}
          <div className="rounded-xl border border-slate-100 p-4">
            <p className="text-xs font-semibold text-[#0F172A] mb-3">Upcoming Appointments</p>
            <div className="space-y-2.5">
              {APPOINTMENTS.map((apt) => (
                <div key={apt.time} className="flex items-center gap-3">
                  <span className="text-[11px] font-semibold text-slate-400 w-10">{apt.time}</span>
                  <span className="w-7 h-7 rounded-full bg-slate-100 flex items-center justify-center text-[10px] font-bold text-slate-500">
                    {apt.name.split(" ").map((n) => n[0]).join("")}
                  </span>
                  <span className="text-xs font-medium text-[#0F172A] flex-1 truncate">{apt.name}</span>
                  <span className={`text-[9px] font-semibold rounded-full px-2 py-0.5 ${apt.tagColor}`}>
                    {apt.tag}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Recent activity */}
          <div className="rounded-xl border border-slate-100 p-4">
            <p className="text-xs font-semibold text-[#0F172A] mb-3">Recent Activity</p>
            <div className="space-y-2.5">
              {ACTIVITY.map((item) => (
                <div key={item.text} className="flex items-start gap-2.5">
                  <span className="w-1.5 h-1.5 rounded-full mt-1.5 shrink-0" style={{ backgroundColor: item.dot }} />
                  <p className="text-[11px] text-slate-500 leading-snug flex-1">{item.text}</p>
                  <span className="text-[9px] text-slate-300 shrink-0">{item.time}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
